export const SHOP_BY_CALLBACK_FIELD_NAMES = {
  TERM: 'shopByCallback.sbcTerm',
  APR: 'shopByCallback.sbcApr',
  LTV: 'shopByCallback.sbcLtv',
} as const;
